/**
 * Utility functions
 */

export const dist = (a, b) => {
    const da = a.x - b.x;
    const db = a.y - b.y;

    return Math.sqrt((da * da) + (db * db));
};


export const noop = () => {};
export const noopTrue = () => true;


export const hexToArr = hex => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? [
        parseInt(result[1], 16) / 255,
        parseInt(result[2], 16) / 255,
        parseInt(result[3], 16) / 255
    ] : null;
}


export const repeatStr = (str, num) => {
    let ans = '';

    for (let i = 0; i < num; i++) {
        ans += str.replace(/#/g, i);
        ans += '\r\n';
    }

    return ans;
};


export const rgbToVal = color => color.r << 16 | color.g << 8 | color.b;


export const uuidv4 = () => (
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  })
)
